import { useQuery } from 'react-query';
import { QueryKeys } from '.';

import { useApi } from '../../context';
import { Industry } from '../../models';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';

export function useIndustriesQuery() {
	const api = useApi();

	return useQuery(QueryKeys.Lookups.Industries, () =>
		AxiosUtils.getResponseData<Industry[]>(api.get(CerebroApiEndpoints.Lookups.Industries))
	);
}
